const employeeEndpoints = {
  EMPLOYEE_DRAFT: (facilityId: string) =>
    `loopay-employee-management/facilities/${facilityId}/employees/draft`,
  EMPLOYEE_FINALIZE: (facilityId: string) =>
    `loopay-employee-management/facilities/${facilityId}/employees/finalize`,
  EMPLOYEE_UPDATE: (employeeId: string) =>
    `loopay-employee-management/employees/${employeeId}`,
  EMPLOYEE_STATUS: (employeeId: string) =>
    `loopay-employee-management/employees/${employeeId}/status`,
} as const;

export default employeeEndpoints;
